import { styled } from '@mui/material/styles';
import { IconButton, Box } from '@mui/material';

export const CloseButton = styled(IconButton)({
  position: 'absolute',
  right: 8,
  top: 8,
  color: "#000"
});

export const DialogContainer = styled(Box)({
  width: "240px"
});

export const ColorOptionRow = styled(Box)({
  display: "flex",
  margin: "4px 0"
});

export const ColorRadioInput = styled('input')({
  margin: "0 5px 0 0",
  cursor: "pointer"
});

export const ColorLabel = styled('label')<{ color: string }>(({ color }) => ({
  width: "100%",
  height: "32px",
  borderRadius: "3px",
  background: color,
  cursor: "pointer"
}));

export const NoneOptionRow = styled(Box)({
  display: "flex",
  margin: "4px 0px"
});

export const NoneRadioInput = styled('input')({
  margin: "0 5px 0 0"
}); 